// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"

/** JQUERY **/
import './jquery-global'; // https://stackoverflow.com/questions/35358625/jquery-is-not-defined-when-use-es6-import

/** ALPINEJS **/
import Alpine from 'alpinejs'
import morph from '@alpinejs/morph'
window.Alpine = Alpine;
Alpine.plugin(morph)
Alpine.start();

// https://turbo.hotwired.dev/handbook/drive#custom-rendering
document.addEventListener('turbo:before-render', (e) => {
  // override turbo morph with alpine morph
  // permette la copia dello stato dei componenti alpine (di cui turbo se ne frega)
  e.detail.render = (currentEl, newEl) => {
    Alpine.morph(currentEl, newEl)
  }
})

/** PLUGINS **/
//

import './main';